import {Component} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet, RouterLink } from '@angular/router';
import {StorageMap} from '@ngx-pwa/local-storage';
import {originalPrice} from '../../config/price';
import {WindowProvider} from '../../helpers/window-provider';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ErrorModalComponent } from '../../services/error-message/error-modal/error-modal.component';
import { SfBannerComponent } from './sf-banner/sf-banner.component';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';

@Component({
    selector: 'app-storefront',
    templateUrl: './storefront.component.html',
    styleUrls: ['./storefront.component.scss'],
    standalone: true,
    imports: [NgxJsonLdModule, SfBannerComponent, ErrorModalComponent, RouterOutlet, RouterLink, FontAwesomeModule]
})
export class StorefrontComponent {
  public isErrorPage = false;
  public originalPrice = (originalPrice / 100).toFixed(2);

  constructor(private route: ActivatedRoute,
              private router: Router,
              private windowProvider: WindowProvider,
              private storage: StorageMap) {
    this.initProcessRoutedPage();
  }

  public initProcessRoutedPage(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isErrorPage = event.urlAfterRedirects.startsWith('/error');
      }
    });

    this.route.queryParams.subscribe(params => {
      if (params['ref']) {
        this.storage.set('referrer', params['ref']).subscribe(() => {});
      }
    });
  }

  public onRouterOutletActivate(): void {
    this.windowProvider.get().scroll(0, 0);
  }
}
